import { writable } from 'svelte/store';
import { authToken } from '@dopry/svelte-auth0';
import { loadImage, loadWorkflowExecutions } from './api';
export const workflowExecutions = writable({
    loading: undefined,
    error: undefined,
}, (set) => {
    const state = {
        loading: true,
        error: false,
    };
    set(state);
    authToken.subscribe((token) => {
        if (token) {
            loadWorkflowExecutions(token)
                .then((data) => (state.data = data['content']))
                .catch((e) => {
                console.log(e);
                state.error = true;
            })
                .finally(() => {
                state.loading = false;
                set(state);
            });
        }
    });
});
export const selected = writable({
    workflowExecution: undefined,
    inputImageState: undefined,
    resultImageState: undefined,
    feedbackState: undefined,
    loading: undefined,
}, (set) => {
    const state = {
        workflowExecution: undefined,
        inputImageState: { loading: true, error: false },
        resultImageState: { loading: true, error: false },
        feedbackState: { sending: false, error: false, sent: false },
        loading: true,
    };
    set(state);
    workflowExecutions.subscribe((execs) => {
        if (!execs.loading && !execs.error) {
            const selectedExec = execs.data[0];
            state.workflowExecution = selectedExec;
            state.loading = false;
            set(state);
            loadImage(selectedExec.inputContentHash, selectedExec.resultContentHash)
                .then(([inputData, resultData]) => {
                state.inputImageState.data = inputData;
                state.resultImageState.data = resultData;
            })
                .catch((e) => {
                state.inputImageState.error = true;
                state.resultImageState.error = true;
            })
                .finally(() => {
                state.inputImageState.loading = false;
                state.resultImageState.loading = false;
                set(state);
            });
        }
    });
});
